// =============================================================================
// ArquivoView.ts — Arquivos da CPI (#95): bestiário colecionável. Uma ficha
// satírica por inimigo e boss — sprite procedural, nome, bordões (enemies.ts),
// crimes atribuídos (feitos.ts) e os kills acumulados do jogador contra ele.
// Investigado nunca visto vira silhueta "??? — depoimento pendente".
// Desde a issue #122 vive como aba da tela CONQUISTAS E ARQUIVOS, paginada.
// =============================================================================
import { BOSS_TABLE, ENEMY_TABLE, ETYPE_IDS } from '../../../shared/enemies';
import { CPI_PENDENTE, CRIMES_CPI, type FeitosState } from '../../../shared/feitos';
import { fetchPerfil } from '../../infrastructure/MetaClient';
import { ENEMY_SPRITE, spriteFactory } from '../sprites';
import { audio } from '../AudioEngine';
import { $, renderPager } from './dom';

const POR_PAGINA = 10;

const fmt = (n: number): string => n.toLocaleString('pt-BR');

// Sprite procedural ampliado pro DOM (mesma fábrica do jogo, cache interno)
function fichaImg(typeId: string, boss: boolean): string {
  const spriteId = ENEMY_SPRITE[typeId];
  if (!spriteId) return '';
  return `<img class="pix" src="${spriteFactory.dataURL(spriteId, boss ? 3 : 4)}" alt="" />`;
}

export class ArquivoView {
  private feitos: FeitosState | null = null;
  private page = 0;

  show(): void {
    this.page = 0;
    $('arquivo-lista').innerHTML = '<p class="zona-vazia">Desengavetando os processos...</p>';
    $('arquivo-pager').innerHTML = '';
    void this.load();
  }

  private async load(): Promise<void> {
    const res = await fetchPerfil();
    if (!res.ok || !res.feitos) {
      $('arquivo-lista').innerHTML =
        '<p class="zona-vazia">O arquivo está lacrado por decisão monocrática. Tente de novo.</p>';
      return;
    }
    this.feitos = res.feitos;
    this.render();
  }

  private render(): void {
    const feitos = this.feitos!;
    const vistos = new Set(feitos.stats.vistos);
    $('arquivo-resumo').textContent =
      `ARQUIVO ${vistos.size}/${ETYPE_IDS.length} — a CPI segue sem relatório final`;

    const box = $('arquivo-lista');
    box.innerHTML = '';
    // Gavetas paginadas (issue #122): 10 fichas por página
    const pagina = ETYPE_IDS.slice(this.page * POR_PAGINA, (this.page + 1) * POR_PAGINA);
    for (const typeId of pagina) {
      const boss = BOSS_TABLE[typeId];
      const def = boss ?? ENEMY_TABLE[typeId];
      if (!def) continue;
      const visto = vistos.has(typeId);
      const kills = feitos.stats.killsPorTipo[typeId] ?? 0;
      const card = document.createElement('div');
      card.className = `ficha-cpi${visto ? '' : ' pendente'}${boss ? ' chefe' : ''}`;
      if (visto) {
        const bordoes = def.quotes.slice(0, 3).map((q) => `"${q}"`).join(' · ');
        card.innerHTML = `
          <div class="ficha-retrato">${fichaImg(typeId, !!boss)}</div>
          <div class="ficha-info">
            <div class="ficha-nome">${def.nome}
              ${boss ? '<span class="ficha-chefe">CHEFE DE ESCÂNDALO</span>' : ''}</div>
            <p class="ficha-crime"><b>Crimes atribuídos:</b> ${CRIMES_CPI[typeId] ?? 'Investigação em curso.'}</p>
            <p class="ficha-bordoes">${bordoes}</p>
            <div class="ficha-kills">${kills > 0
    ? `<b>${fmt(kills)}</b> neutralizado${kills > 1 ? 's' : ''} por você`
    : 'nenhum neutralizado — o depoente segue solto'}</div>
          </div>`;
      } else {
        // Silhueta: o retrato vira sombra via CSS (.pendente)
        card.innerHTML = `
          <div class="ficha-retrato">${fichaImg(typeId, !!boss)}</div>
          <div class="ficha-info">
            <div class="ficha-nome">${CPI_PENDENTE}</div>
            <p class="ficha-crime">Investigado ainda não intimado. Encontre-o em campo para abrir a ficha.</p>
          </div>`;
      }
      box.appendChild(card);
    }
    renderPager($('arquivo-pager'), ETYPE_IDS.length, this.page, POR_PAGINA, (p) => {
      audio.sfx.urnaKey();
      this.page = p;
      this.render();
    });
  }
}
